// Reads the per-request CSP nonce injected by nginx into the HTML meta tag.
// Must be imported first in every entry point so MUI/Emotion caches capture the correct nonce.
// nginx replaces CSP_NONCE_PLACEHOLDER with the actual $request_id value.
// Vite's html.cspNonce transforms <meta name="csp-nonce" content="..."> into
// <meta property="csp-nonce" nonce="..."> in the built output — check both forms.
(globalThis as any).__cspNonce__ = (
  document.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]')?.getAttribute('nonce') ||
  document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content
) ?? '';

// Auto-nonce all dynamically created <style> elements.
// Required for libraries that inject <style> tags without CSP nonce awareness:
//   - apexcharts (react-apexcharts) — injects global CSS <style> blocks
//   - vite-plugin-css-injected-by-js (e.g. react-voice-visualizer) — injects CSS at module eval time
// CSP3: 'unsafe-inline' in style-src is ignored when a nonce is present, so every
// <style> element must carry the request-scoped nonce or it is blocked.
// This patch must run before any library code — initNonce.ts is the first import.
if ((globalThis as any).__cspNonce__) {
  const _origCreateElement = document.createElement.bind(document);
  (document as any).createElement = function (tagName: any, options?: any): any {
    const el = _origCreateElement(tagName, options);
    if (typeof tagName === 'string' && tagName.toLowerCase() === 'style') {
      el.setAttribute('nonce', (globalThis as any).__cspNonce__);
    }
    return el;
  };
}
